import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'jp',
    messages: {
        'us': require('@/locale/us.json'),
        'jp': require('@/locale/jp.json')
    }
});

export default i18n;